// extracted by mini-css-extract-plugin
export var fileUpload = "_dq-1";
export var modalButton = "_dq-0";